import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;

  if (isEmpty(profile)) {
    return false;
  }

  if (profile.age === null) {
    return false;
  }
  return true;
};
//VERIFY IF THE JWT IS SET
const getIsAgeSet = createSelector(getData, isSet => isSet);
export default getIsAgeSet;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getIsAgeSet.js